import {useQuery} from '@tanstack/react-query';
import {reallocationApi} from '../../api';
export function useDeviceReallocation(deviceId:number){
 const q=useQuery({queryKey:['reallocations','SALES_AGENT'],queryFn:reallocationApi.list,staleTime:0});
 return q.data?.find(r=>r.viewerSide==='GIVER'&&['SCANNING','REVIEW'].includes(r.status)&&r.deviceIds?.includes(deviceId));
}
